<template>
  <!-- <div class="items">
    <div class="recordItem" > -->
      <van-cell-group @click="$emit('click', user) ">

        <van-cell icon="user-o" is-link>
          <template #title>
            <span>{{ user.客户姓名 }}</span>
          </template>
          <template >
            <span class="custom-tel">{{ user.客户电话 | maskTel}}</span>
          </template>
        </van-cell>
        <van-cell class="custom-address">
          <!-- <span >{{ user.详细地址 }} </span> -->
          
           <span v-if="user.回访记录" > {{
             user.回访记录[0]["回访时刻"] | parseTime('{y}-{m}-{d} {h}:{i}')
             }}
             备注:{{user.回访记录[0]["备注"]}}</span>
          <span v-else > 未回访</span>
        </van-cell>
      </van-cell-group>
    <!-- </div>
  </div> -->
</template>
<script>
 import { parseTime } from '@/utils/date';
export default {
  name: "record",
  props: ["user"],

  methods: {
    // goEdit(item) {
       
    //   this.$router.push({ name: "recordList", params: { user: item } });
    // },
    
  },
  components: {},
};
</script>
<style scoped lang="less">
.items {
  background: #fff;
  box-sizing: border-box;
  //padding: 5px;
  //margin-bottom: 5px;
}
.custom-address{
font-size: 10px;
padding-top: 0px;
padding-left: 30px;
}
.custom-tel{
font-size: 12px;
padding-top: 0px;
padding-left: 30px;
}
.recordItem {
  display: flex;
  justify-content: space-between;
  font-size: 14px;
  .icon,
  // .record {
  //   width: 30px;
  //   display: flex;
  //   justify-content: center;
  //   align-items: center;
  // }
  .icon {
    font-size: 18px;
  }
  // .record {
  //   width: 50px;
  //   color: #1989fa;
  // }
  // .message {
  //   flex: 1;
  //   //   display: flex;
  //   //   flex-direction: row;
  //   //   align-items: center;
  //   span {
  //     display: block;
  //     padding: 3px;
  //   }
  // }
}
</style>